// Copyright (c) 2022 by Move Closer

import { AnyObject } from '@movecloser/front-core'

import {
  ProductData,
  ProductReviewData,
  ProductReviewPayload,
  ProductStockNotificationPayload,
  RelatedSuggestedProducts
} from '../../../contexts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl> (original)
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl> (edited)
 */
export interface IProductsRepository {
  /**
   * Add review to product.
   *
   * @param productSku - sku (id) of the product
   * @param payload - review data.
   */
  addReview (productSku: string, payload: AnyObject): Promise<void>

  /**
   * Load the list of products bu their sku
   */
  loadProductsBySkus (skus?: string[] | null, action?: string | null): Promise<ProductData[]>
}

/**
 * @author Filip Rurak<filip.rurak@movecloser.pl>
 */
export interface IProductReviewsRepository {
  /**
   * Add new review
   */
  createProductReview (payload: ProductReviewPayload): Promise<void>

  /**
   * List of product reviews
   */
  loadProductReviews (productSkus: string[]): Promise<ProductReviewData[]>
}

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export interface IProductStockRepository {
  /**
   * Subscribe to stock notification for product
   */
  subscribeToStockNotification (payload: ProductStockNotificationPayload): Promise<void>
}

/**
 * @author Filip Rurak<filip.rurak@movecloser.pl>
 */
export const ProductsRepositoryType = Symbol.for('IProductsRepository')

/**
 * @author Filip Rurak<filip.rurak@movecloser.pl>
 */
export const ReviewsRepositoryType = Symbol.for('IProductReviewsRepository')

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const ProductStockRepositoryType = Symbol.for('IProductStockRepository')

/**
 * @author Filip Rurak<filip.rurak@movecloser.pl>
 */
export enum RecommendationAction {
  // AddToCart = 'addToCart', !DEPRECATED
  AddToCart = 'addToCart',
  BrandAndCategory = 'brandAndCategory',
  Complementary = 'complementary',
  Recommendation = 'recommendation',
  Category = 'category',
  Line = 'line',
  Brand = 'brand'
}
